// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3KQ_R","header":"PatientQuestionnaire_header__3BBb7","info":"PatientQuestionnaire_info__2Toz0"};